import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeTwelfthVariantConfig } from '@shared/models';
import {
  AmountPartsPipe,
  RewardPipe,
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant12',
  styleUrl: './variant12.component.scss',
  templateUrl: './variant12.component.html',
  imports: [
    RewardPipe,
    SafePipe,
    AmountPartsPipe,
    ElementDirective,
    WinCardComponent,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
    TransformUrlToBgPipe,
    NgOptimizedImage,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Variant12Component extends FrequencyBaseClass {
  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeTwelfthVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  protected remainingVisits = computed(
    () => this.challenge().target - this.challenge().progress
  );

  protected canUnselect = computed(() =>
    this.challenge().canBeUnselected(this.phase())
  );

  protected headerRewardPoints(): number {
    return this.challenge().rewardRatio;
  }
}
